import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

const Invoices: React.FC = () => {
  return (
    <Box>
      <Heading size="lg" mb={4} color="white">Invoice Manager</Heading>
      <Text color="gray.300">
        Invoice generation and management interface will be implemented here.
        This will include invoice creation, PDF generation, and payment tracking.
      </Text>
    </Box>
  );
};

export default Invoices;